import React from 'react';

import Loadable from 'react-loadable';

import { withStatsd } from 'src/components/performance-metrics/with-statsd';

import getMonacoWorker from '../utils/get-monaco-worker';

import FileLoading from './file-loading';

export default Loadable({
  loader: () => {
    const loadEditor = import(
      /* webpackChunkName: "react-monaco-editor" */ 'react-monaco-editor'
    );

    /**
     * Monaco (specifically, its language services) uses web workers to compute heavy stuff
     * outside of the UI thread for better performance. Web workers can't load their scripts
     * from a different domain from that which they're run on. That's an issue for us, because
     * we host our JS bundles (including the web worker code) on a CDN at a different domain
     * than our app runs on. Microsoft presents a couple of options here:
     *
     * https://github.com/Microsoft/monaco-editor/blob/14f6229243233f456eb688c0dbdf505c61731b64/docs/integrate-amd-cross.md
     *
     * Using a proxy is not an option for us right now, and the dataURI solution
     * doesn't work correctly in Safari. However, a similar approach using a Blob and creating
     * passing an object URL created from that Blob to the web worker works across all of our
     * supported browsers. More information on the Blob approach can be found here:
     *
     * https://benohead.com/cross-domain-cross-browser-web-workers/
     *
     * The final piece here is `importScripts`, which is part of the web worker API and allows an
     * already running worker to load and run the contents of a script hosted on another domain.
     */
    loadEditor.then(() => {
      // This code must run after the monaco module code has been evaluated/imported
      window.MonacoEnvironment = {
        // @ts-ignore TODO: fix noImplicitAny error here
        getWorker: (_, label) => getMonacoWorker(label),
      };
    });

    return loadEditor;
  },
  loading: () => <FileLoading />,
  render(loaded, props) {
    const ReactMonacoEditor = loaded.default;

    if (!this.InstrumentedComponent) {
      this.InstrumentedComponent = withStatsd(
        'performance.source.file.rendered'
      )(ReactMonacoEditor);
    }

    const InstrumentedReactMonacoEditor = this.InstrumentedComponent;

    return <InstrumentedReactMonacoEditor {...props} />;
  },
});
